// Contenu explicatif détaillé par module (page vitrine de chaque module)
export const MODULE_CONTENT = {
  punch: {
    hero: "Le temps de vos équipes, maîtrisé au chantier.",
    intro:
      "PROGÈRE PUNCH digitalise la gestion du temps sur vos chantiers. Vos employés poinçonnent depuis leur téléphone, la géolocalisation confirme leur présence, et vous générez vos rapports CCQ en un clic.",
    features: [
      { title: "Poinçon mobile", text: "Entrées et sorties depuis le téléphone, même hors ligne." },
      { title: "Géolocalisation", text: "Validation automatique de la présence sur le bon chantier." },
      { title: "Feuilles de temps", text: "Compilation automatique des heures par employé et par projet." },
      { title: "Rapports CCQ", text: "Génération conforme des rapports pour la Commission de la construction du Québec." },
      { title: "Suivi par chantier", text: "Heures, coûts de main-d'œuvre et présences par site en temps réel." },
      { title: "Approbations", text: "Validation des feuilles de temps par les contremaîtres et gestionnaires." },
    ],
    useCases: [
      "Entrepreneurs généraux qui gèrent plusieurs chantiers simultanément.",
      "Sous-traitants soumis aux exigences de la CCQ.",
      "Contremaîtres qui veulent suivre les heures en direct.",
    ],
  },
  crm: {
    hero: "Transformez vos prospects en contrats signés.",
    intro:
      "PROGÈRE CRM centralise vos clients, votre pipeline de ventes et vos soumissions. Suivez chaque opportunité, relancez au bon moment et ne perdez plus jamais un contrat par oubli.",
    features: [
      { title: "Fiches clients", text: "Historique complet des échanges, projets et documents par client." },
      { title: "Pipeline visuel", text: "Suivez vos opportunités de la prise de contact à la signature." },
      { title: "Soumissions", text: "Créez et envoyez vos soumissions, suivez leur statut d'acceptation." },
      { title: "Relances automatiques", text: "Rappels et suivis planifiés pour ne rien laisser tomber." },
      { title: "Suivi des ventes", text: "Tableaux de bord de performance commerciale et taux de conversion." },
      { title: "Gestion des contacts", text: "Segmentez vos clients et prospects par type et par région." },
    ],
    useCases: [
      "Équipes de vente qui gèrent de nombreuses soumissions.",
      "Entreprises qui veulent structurer leur suivi commercial.",
      "Gestionnaires qui suivent le taux de conversion et les prévisions.",
    ],
  },
  erp: {
    hero: "Le cœur opérationnel de vos projets de construction.",
    intro:
      "PROGÈRE ERP orchestre vos projets, documents, échéanciers, achats, inventaire et ressources. Avec le module premium TAKE OFF, réalisez vos métrés et quantitatifs directement à partir de vos plans.",
    features: [
      { title: "Gestion de projets", text: "Planification, phases, jalons et suivi d'avancement." },
      { title: "Échéanciers", text: "Diagrammes de Gantt et calendriers de chantier partagés." },
      { title: "Documents", text: "Plans, contrats et devis centralisés et versionnés." },
      { title: "Achats & inventaire", text: "Bons de commande, réception et suivi des matériaux." },
      { title: "Ressources", text: "Affectation de la main-d'œuvre et des équipements." },
      { title: "TAKE OFF (Premium)", text: "Métrés et quantitatifs directement sur vos plans numériques." },
    ],
    useCases: [
      "Entreprises qui gèrent des projets complexes multi-phases.",
      "Estimateurs qui ont besoin de métrés précis (TAKE OFF).",
      "Gestionnaires qui veulent tout centraliser en un seul outil.",
    ],
  },
  compta: {
    hero: "Votre comptabilité de construction, sans casse-tête.",
    intro:
      "PROGÈRE COMPTA gère votre facturation, vos dépenses, votre comptabilité et vos rapports financiers. La paie intégrée (module PAIE) traite automatiquement la paie CCQ de vos employés.",
    features: [
      { title: "Facturation", text: "Factures professionnelles, suivi des paiements et relances." },
      { title: "Dépenses", text: "Saisie et catégorisation des dépenses par projet." },
      { title: "Comptabilité", text: "Grand livre, conciliation bancaire et états financiers." },
      { title: "Paie CCQ (PAIE)", text: "Traitement de la paie conforme aux règles de la construction." },
      { title: "Rapports financiers", text: "Rentabilité par projet, marges et flux de trésorerie." },
      { title: "Taxes", text: "Gestion de la TPS/TVQ et préparation des remises." },
    ],
    useCases: [
      "Entreprises qui veulent lier comptabilité et projets.",
      "Employeurs assujettis à la paie CCQ.",
      "Dirigeants qui suivent la rentabilité en temps réel.",
    ],
  },
  "devis-ai": {
    hero: "Des devis intelligents, générés en minutes.",
    intro:
      "PROGÈRE DEVIS AI accélère la création de vos soumissions grâce à l'intelligence artificielle. Décrivez le projet, l'IA estime les quantités et les coûts, et génère un devis professionnel prêt à envoyer.",
    features: [
      { title: "Estimation par IA", text: "L'IA propose quantités et coûts à partir de la description du projet." },
      { title: "Génération rapide", text: "Un devis complet et structuré en quelques minutes." },
      { title: "Bibliothèque de prix", text: "Base de prix personnalisable pour vos matériaux et main-d'œuvre." },
      { title: "Modèles professionnels", text: "Mise en page soignée à votre image de marque." },
      { title: "Ajustement intelligent", text: "Recalcul automatique lors d'un changement de portée." },
      { title: "Export & envoi", text: "PDF, envoi au client et suivi d'acceptation." },
    ],
    useCases: [
      "Estimateurs qui produisent beaucoup de soumissions.",
      "Entrepreneurs qui veulent répondre plus vite aux appels d'offres.",
      "Entreprises qui veulent standardiser leurs devis.",
    ],
  },
  support: {
    hero: "Une aide toujours disponible pour vos équipes.",
    intro:
      "PROGÈRE SUPPORT est votre centre d'aide unifié : billets de support, documentation et assistance pour tout l'écosystème PROGÈRE. Vos questions trouvent réponse rapidement.",
    features: [
      { title: "Billets de support", text: "Créez et suivez vos demandes d'assistance." },
      { title: "Base de connaissances", text: "Documentation et guides pour chaque module." },
      { title: "Assistance prioritaire", text: "Temps de réponse accélérés selon votre forfait." },
      { title: "Historique", text: "Toutes vos demandes et réponses au même endroit." },
      { title: "Tutoriels", text: "Vidéos et articles pour former vos équipes." },
      { title: "Notifications", text: "Suivi en temps réel de l'état de vos billets." },
    ],
    useCases: [
      "Toutes les entreprises de l'écosystème PROGÈRE.",
      "Équipes qui veulent une prise en main rapide.",
      "Gestionnaires qui veulent centraliser le support.",
    ],
  },
};
